import { Slice, createSlice } from "@reduxjs/toolkit";
import { fetchAIAnomalyTable } from "../thunk/SitesOverviewThunk";

const initialData: any = [];

const AnomalytableChartSlice: Slice<any, {}, "AnomalytableChartSlice"> = createSlice({
    name: "AnomalytableChartSlice",
    initialState: { data: initialData, isLoading: false, error: "" },
    reducers: {},
    extraReducers(builder) {
        builder.addCase(fetchAIAnomalyTable.pending, (state, action) => {
            state.isLoading = true
        });
        builder.addCase(fetchAIAnomalyTable.fulfilled, (state, action) => {
            state.isLoading = false
            state.data = action.payload
        });
        builder.addCase(fetchAIAnomalyTable.rejected, (state, action) => {
            state.isLoading = false
            state.error = action.error.message ?? ""
        });
    }
})

export default AnomalytableChartSlice;
